document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".interactive__section-box");
  const leftImg = wrapper.querySelector(".interac__left-box img");
  const rightImg = wrapper.querySelector(".interac__right-box img");

  wrapper.addEventListener("mousemove", function (e) {
    const rect = wrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const moveX = (x - centerX) / 40; // lower divisor = more movement
    const moveY = (y - centerY) / 40;

    leftImg.style.transform = `translate(${moveX}px, ${moveY}px) scale(1.02)`;
    rightImg.style.transform = `translate(${-moveX}px, ${-moveY}px) scale(1.02)`;
  });

  wrapper.addEventListener("mouseleave", function () {
    leftImg.style.transform = "translate(0px, 0px) scale(1)";
    rightImg.style.transform = "translate(0px, 0px) scale(1)";
  });
});
